<template>
  <VForm v-model="isFormValid">
    <VLayout>
      <VFlex
        xs12
        sm6
        class="pr-2"
      >
        <VTextField
          v-model="password"
          :error-messages="errorMessages"
          :rules="[$rules.isRequired, $rules.isValidPassword]"
          :append-icon="showPassword ? 'visibility_off' : 'visibility'"
          :type="showPassword ? 'text' : 'password'"
          :required="true"
          :label="$nt('label')"
          name="password-input"
          @keydown.enter="$emit('submit')"
          @click:append="showPassword = !showPassword"
        />
      </VFlex>
      <VFlex
        xs12
        sm6
      >
        <VTextField
          v-model="passwordConfirm"
          :error-messages="errorMessages"
          :rules="[$rules.isRequired, $rules.isPasswordMatch([password, passwordConfirm])]"
          :append-icon="showPasswordConfirm ? 'visibility_off' : 'visibility'"
          :type="showPasswordConfirm ? 'text' : 'password'"
          :required="true"
          :label="$nt('labelConfirm')"
          @keydown.enter="$emit('submit')"
          @click:append="showPasswordConfirm = !showPasswordConfirm"
        />
      </VFlex>
    </VLayout>
  </VForm>
</template>

<script>
export default {
  name: 'PasswordPair',
  props: ['errorMessages'],
  data () {
    return {
      isFormValid: false,
      showPassword: false,
      showPasswordConfirm: false,
      password: '',
      passwordConfirm: ''
    }
  },
  watch: {
    isFormValid (isValid) {
      isValid ? this.$emit('validPasswordPair', this.password) : this.$emit('invalidPasswordPair')
    }
  }
}
</script>
